module.exports = "https://coursera_assets.s3.amazonaws.com/images/28d6fd795221910bde7e99b9dae7b0d4.svg";